import PropTypes from "prop-types"
import { RefuseCheckCancel } from '../em-cancelamento.service'
import { useGlobalContext } from 'hooks/useGlobalContext';
import intl from 'react-intl-universal'
import { formatErrorMessage } from 'utils/handle-error';
import Button from "components/button";

const WaitingCheckRefusedButton = ({ stopLoading, startLoading, refresh, idPedido }) => {
  const { showFeedback } = useGlobalContext();

  const handleCompletCheckRefused = async () => {
    try {
      startLoading()
      await RefuseCheckCancel(idPedido);
      refresh()
      showFeedback(intl.get('stocks.timeline.feedback.scienceSuccessfullyRegistered'))
    } catch (e) {
      showFeedback(formatErrorMessage(e))
    }
    stopLoading()
  }

  return (
    <Button
      buttonType="primary"
      value="OK"
      onClick={handleCompletCheckRefused}
      className='btn-check-cancellation'
    />
  )
}

WaitingCheckRefusedButton.propTypes = {
  idPedido: PropTypes.any.isRequired,
  refresh: PropTypes.func.isRequired,
  startLoading: PropTypes.func.isRequired,
  stopLoading: PropTypes.func.isRequired
}

export default WaitingCheckRefusedButton
